<h1 mat-dialog-title>Pobierz dane z KRS</h1>
<mat-dialog-content class="mat-typography">
	<mat-form-field>
		<input matInput type="number" placeholder="Wprowadź numer NIP" #organizationData />
	</mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-raised-button mat-dialog-close color="warn">Anuluj</button>
	<button mat-raised-button cdkFocusInitial color="primary" (click)="uploadOrganizationData(organizationData.value)">
		Wgraj dane
	</button>
</mat-dialog-actions>
